import styled from 'styled-components';
import { ReactComponent as Key_ } from 'Images/icon-action-bar-token.svg';

export const Wrapper = styled.div`
  display: flex;
  user-select: none;
  margin-bottom: 25px;
  padding-right: 36px;
`;
Wrapper.displayName = 'Wrapper';

export const ButtonWrapper = styled.div`
  margin-left: auto;
`;
ButtonWrapper.displayName = 'ButtonWrapper';

export const Key = styled(Key_)`
  cursor: default;
  g > path {
    fill: #90a9c0;
  }
  margin: 10px 13px 0 0;
`;
Key.displayName = 'Key';
